import React, { memo } from "react";
import { CCard } from "@coreui/react";
import { getColSpanClasses } from "src/utils/getColSpanClasses";

export const PhaseCard = memo(({
  phaseItem,
  phaseIndex,
  onTogglePhase,
  className = "",
  style,
  cardClassName = "",
  cardStyle,
  title,
  metrics,
  rightActions,
}) => {
  if (!phaseItem) return null;

  const renderedMetrics = typeof metrics === "function"
    ? metrics(phaseItem, { phaseIndex })
    : metrics;

  return (
    <CCard
      style={{ ...cardStyle, ...style }}
      className={`shadow-sm p-4 mb-0 cursor-pointer !rounded-lg hover:bg-gray-50 ${cardClassName} ${className}`.trim()}
      onClick={() => onTogglePhase && onTogglePhase(phaseItem.Phase)}
    >
      <div className="grid grid-cols-12 items-start">
        {/* Phase Title */}
        <div id="Phase" className="col-span-12 md:col-span-3 mb-2 md:mb-0 pr-2">
          {title ? (
            typeof title === "function" ? title(phaseItem, { phaseIndex }) : title
          ) : (
            <div className="flex items-start">
              {phaseIndex !== undefined && phaseIndex !== null && (
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#3f5253] text-white flex items-center justify-center text-xs font-bold mr-3 mt-0.5">
                  {phaseIndex + 1}
                </span>
              )}
              <div className="font-bold text-[#23303d] text-sm md:text-base leading-tight">
                {phaseItem.Phase?.toUpperCase()}
              </div>
            </div>
          )}
        </div>

        {/* Phase Metrics */}
        <div
          id="PhaseMetrics"
          className={`col-span-12 ${rightActions ? "md:col-span-6 lg:col-span-7" : "md:col-span-9"} mb-2 md:mb-0`}
        >
          {Array.isArray(renderedMetrics) ? (
            <div className="grid grid-cols-12 items-start">
              {renderedMetrics.map((col, colIdx) => {
                const alignClass =
                  col.align === "right"
                    ? "text-right"
                    : col.align === "center"
                      ? "text-center"
                      : "text-left";

                return (
                  <div
                    key={col.id || colIdx}
                    id={col.id}
                    className={`px-1 ${getColSpanClasses(col)} ${alignClass} ${col.className || ""}`.trim()}
                  >
                    {col.label && (
                      <span className="text-[11px] font-medium block text-gray-500 leading-tight">
                        {col.label}
                      </span>
                    )}
                    {typeof col.value === "function"
                      ? col.value(phaseItem, { phaseIndex })
                      : (col.value ?? (
                        <div className="text-sm md:text-base font-bold text-[#23303d] mt-1 whitespace-nowrap">
                          {col.text || "---"}
                        </div>
                      ))}
                  </div>
                );
              })}
            </div>
          ) : (
            renderedMetrics
          )}
        </div>

        {/* Right Actions Slot */}
        {rightActions && (
          <div className="col-span-12 md:col-span-3 lg:col-span-2 text-center">
            {typeof rightActions === "function"
              ? rightActions(phaseItem, { phaseIndex })
              : rightActions}
          </div>
        )}
      </div>
    </CCard>
  );
});

export default PhaseCard;
